import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const sections = [
  '#bd3633',
  '#90374a',
  '#623c65',
  '#374580',
  '#1b4f9c',
];

const Slider = props => (
  <div className='slider'>
    <h4>{props.title}</h4>
    <div className='bar'>
      {_.map(sections, s => (
        <span
          className='section'
          key={s}
          style={{ backgroundColor: s }}
        />
      ))}
    </div>
    {props.position && props.position > 0 ?
      <div
        className='indicator'
        style={{
          left: `calc(${(props.position * 20) - 10}% - 15px)`,
          backgroundColor: sections[props.position - 1],
        }}
      >
        {props.position}
        <span
          className='arrow'
          style={{
            backgroundColor: sections[props.position - 1],
          }}
        />
      </div> : null
    }
    <div className='description'>
      {props.description}
    </div>
  </div>
);

Slider.propTypes = {
  position: PropTypes.number,
  title: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
};

Slider.defaultProps = {
  position: 0,
  title: '',
  description: {},
};

export default Slider;



// WEBPACK FOOTER //
// ./src/views/Components/Slider.js